import Vue from "vue";

import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";
import router from "@/router";

const {
  GET_POINTS_OF_SALE,
  REGISTER_POINTS_OF_SALE,
  UPDATE_POINTS_OF_SALE,
  GET_POINT_OF_SALE_STATUS,
  CHANGE_SUPERVISOR_PASSWORD,
} = ENDPOINTS;

Vue.prototype.$pointOfSale = new Vue({
  data() {
    return {
      actionType: "new",
      loading: false,
      filterLoading: false,
      cadastro: {
        idpdv: "",
        loading: false,
        dados_cadastrais: {
          pessoa: "JURIDICA",
          razao_social: "",
          cnpj: "",
          nome_representante: "",
          cpf: "",
          rg: "",
          rg_orgao: "",
          email: "",
          celular: "",
          regional: "",
          status: "",
          agente_vinculado: "",
          tipo_ponto_venda: "",
          cep: "",
          estado: "",
          cidade: "",
          bairro: "",
          logradouro: "",
          complemento: "",
          error: {
            razao_social: [],
            cnpj: [],
            nome_representante: [],
            cpf: [],
            rg: [],
            rg_orgao: [],
            email: [],
            celular: [],
            regional: [],
            status: [],
            agente_vinculado: [],
            tipo_ponto_venda: [],
            cep: [],
            estado: [],
            cidade: [],
            bairro: [],
            logradouro: [],
          },
        },
        comissao_antecipacao: {
          comissao: "3",
          porcentagem_customizada: "",
          observacoes: "",
          error: {
            comissao: [],
            porcentagem_customizada: [],
          },
        },
        dados_bancarios: {
          nome_titular: "",
          banco: "",
          agencia: "",
          tipo_de_conta: "CORRENTE",
          numero_conta: "",
          digito: "",
          error: {
            nome_titular: [],
            banco: [],
            agencia: [],
            tipo_de_conta: [],
            numero_conta: [],
            digito: [],
          },
        },
        documentos: {
          documento: "",
          documento_upload: { doc: null },
          loading_documento: false,
          documento_array_pj: [],
          documento_array_pf: [],
          error: {
            documento: [],
          },
        },
        contratos: {
          template: "",
          error: {
            template: [],
          },
        },
        equipamentos: {
          link_venda: "",
          rede_vendas_old: "",
          rede_vendas: "PRIVADA",
          selectedStore: null,
          hasSupervisorPass: false,
          supervisorPassword: "",
          oldPassword: "",
          newPassword: "",
          confirmPassword: "",
          equipamentos_array: [],
        },
      },
      pontos_de_venda: [],
      loading_equip: false,
      lista_equipamentos: [],
      status_pdv: [],
      loading_status_pdv: false,
      text: "",
      funcao: "",
      indexValue: "",
      indexImageOrDoc: "",
      valueImageOrDoc: "",
      visualizarImagem: "",
      tipo_docs_pf: [
        {
          key: "Comprovante de Endereço ",
          value: "pdf_comprovante_endereco",
          show: true,
        },
        {
          key: "Documento (RG, CPF ou CNH)",
          value: "pdf_documento",
          show: true,
        },
      ],
      tipo_docs_pj: [
        {
          key: "Comprovante de Endereço ",
          value: "pdf_comprovante_endereco",
          show: true,
        },
        { key: "Contrato Social", value: "pdf_contrato_social", show: true },
        { key: "Procuração", value: "pdf_procuracao", show: true },
      ],
      filtros: [],
      filter: {
        nome: "",
        cpf: "",
        cnpj: "",
        status: "",
        tipoPessoa: "",
        email: "",
        dataInicio: "",
        dataFim: "",
      },
    };
  },

  methods: {
    /**
     * @description - Método para listagem de pontos de venda
     */
    getPointsOfSale() {
      const { post } = this.$axios;
      this.loading = true;
      post(GET_POINTS_OF_SALE).then(response => {
        if (response) {
          this.pontos_de_venda = response;
          this.loading = false;
        }
      });
    },

    /**
     * @description - Método para cadastrar ponto de venda
     */
    async registerPointOfSale() {
      const { post } = this.$axios;
      this.cadastro.loading = true;
      let dados = {};
      let documentos = {};
      let equipamentos = [];

      if (this.cadastro.equipamentos.equipamentos_array.length > 0) {
        this.cadastro.equipamentos.equipamentos_array.forEach(equipamento => {
          equipamentos.push(equipamento.idequipamento);
        });

        equipamentos.join(";");
      }

      if (this.cadastro.dados_cadastrais.pessoa == "JURIDICA") {
        for (
          let index = 0;
          index < this.cadastro.documentos.documento_array_pj.length;
          index++
        ) {
          const element = this.cadastro.documentos.documento_array_pj[index];

          Object.keys(element) == "pdf_comprovante_endereco"
            ? (documentos.pdf_comprovante_endereco =
                element.pdf_comprovante_endereco)
            : "";
          Object.keys(element) == "pdf_contrato_social"
            ? (documentos.pdf_contrato_social = element.pdf_contrato_social)
            : "";
          Object.keys(element) == "pdf_procuracao"
            ? (documentos.pdf_procuracao = element.pdf_procuracao)
            : "";
        }

        dados.dados_cadastrais = {
          tipo_pessoa: this.cadastro.dados_cadastrais.pessoa,
          razao_social: this.cadastro.dados_cadastrais.razao_social,
          cnpj: this.cadastro.dados_cadastrais.cnpj,

          representante_nome: this.cadastro.dados_cadastrais.nome_representante,
          representante_cpf: this.cadastro.dados_cadastrais.cpf,
          representante_rg: this.cadastro.dados_cadastrais.rg,
          representante_rg_orgao: this.cadastro.dados_cadastrais.rg_orgao,
          representante_email: this.cadastro.dados_cadastrais.email,
          celular: this.cadastro.dados_cadastrais.celular,

          nidregional: this.cadastro.dados_cadastrais.regional,
          status: this.cadastro.dados_cadastrais.status,
          idagente: "",
          idtipo_pdv: this.cadastro.dados_cadastrais.tipo_ponto_venda,

          end_cep: this.cadastro.dados_cadastrais.cep,
          end_estado: this.cadastro.dados_cadastrais.estado,
          end_cidade: this.cadastro.dados_cadastrais.cidade,
          end_bairro: this.cadastro.dados_cadastrais.bairro,
          end_logradouro: this.cadastro.dados_cadastrais.logradouro,
          end_complemento: this.cadastro.dados_cadastrais.complemento,
        };
      } else {
        for (
          let index = 0;
          index < this.cadastro.documentos.documento_array_pf.length;
          index++
        ) {
          const element = this.cadastro.documentos.documento_array_pf[index];

          Object.keys(element) == "pdf_comprovante_endereco"
            ? (documentos.pdf_comprovante_endereco =
                element.pdf_comprovante_endereco)
            : "";
          Object.keys(element) == "pdf_documento"
            ? (documentos.pdf_documento = element.pdf_documento)
            : "";
        }
        dados.dados_cadastrais = {
          tipo_pessoa: this.cadastro.dados_cadastrais.pessoa,
          representante_nome: this.cadastro.dados_cadastrais.nome_representante,
          representante_cpf: this.cadastro.dados_cadastrais.cpf,
          representante_rg: this.cadastro.dados_cadastrais.rg,
          representante_rg_orgao: this.cadastro.dados_cadastrais.rg_orgao,
          representante_email: this.cadastro.dados_cadastrais.email,
          representante_celular: this.cadastro.dados_cadastrais.celular,

          nidregional: this.cadastro.dados_cadastrais.regional,
          status: this.cadastro.dados_cadastrais.status,
          idagente: "",
          idtipo_pdv: this.cadastro.dados_cadastrais.tipo_ponto_venda,

          end_cep: this.cadastro.dados_cadastrais.cep,
          end_estado: this.cadastro.dados_cadastrais.estado,
          end_cidade: this.cadastro.dados_cadastrais.cidade,
          end_bairro: this.cadastro.dados_cadastrais.bairro,
          end_logradouro: this.cadastro.dados_cadastrais.logradouro,
          end_complemento: this.cadastro.dados_cadastrais.complemento,
        };
      }

      (dados.comissao_antecipacao = {
        comissao: this.cadastro.comissao_antecipacao.comissao,
        comissao_porcentagem_custom:
          this.cadastro.comissao_antecipacao.porcentagem_customizada,
        observacoes: this.cadastro.comissao_antecipacao.observacoes,
      }),
        (dados.dados_bancarios = {
          nome_titular: this.cadastro.dados_bancarios.nome_titular,
          banco: this.cadastro.dados_bancarios.banco,
          agencia: this.cadastro.dados_bancarios.agencia,
          tipo_conta: this.cadastro.dados_bancarios.tipo_de_conta,
          numero_conta: this.cadastro.dados_bancarios.numero_conta,
          digito_conta: this.cadastro.dados_bancarios.digito,
        }),
        (dados.documentos = documentos),
        (dados.equipamentos = {
          link_vendas: this.cadastro.equipamentos.link_venda,
          rede_vendas: this.cadastro.equipamentos.rede_vendas,
          loja: this.cadastro.equipamentos.selectedStore,
          senha_supervisor: this.cadastro.equipamentos.supervisorPassword,
          equipamentos: equipamentos.join(";") || "",
        });

      post(REGISTER_POINTS_OF_SALE, dados)
        .then(response => {
          if (response) {
            this.clearPointOfSaleForm();
            router.push({
              name: "salePoint",
            });
          }
          this.cadastro.loading = false;
        })
        .catch(() => {
          this.cadastro.loading = false;
        });
    },

    /**
     * @description - Método para alterar ponto de venda
     */
    async changePointOfSale() {
      const { put } = this.$axios;
      this.cadastro.loading = true;
      let dados = {};
      let documentos = {};
      let equipamentos = [];

      if (this.cadastro.equipamentos.equipamentos_array.length > 0) {
        this.cadastro.equipamentos.equipamentos_array.forEach(equipamento => {
          equipamentos.push(equipamento.idequipamento);
        });

        equipamentos.join(";");
      }

      if (
        this.cadastro.equipamentos.rede_vendas_old != "" &&
        this.cadastro.equipamentos.rede_vendas_old !=
          this.cadastro.equipamentos.rede_vendas
      ) {
        this.cadastro.equipamentos.link_venda = "";
      }

      if (this.cadastro.dados_cadastrais.pessoa == "JURIDICA") {
        for (
          let index = 0;
          index < this.cadastro.documentos.documento_array_pj.length;
          index++
        ) {
          const element = this.cadastro.documentos.documento_array_pj[index];

          Object.keys(element) == "pdf_comprovante_endereco"
            ? (documentos.pdf_comprovante_endereco =
                element.pdf_comprovante_endereco)
            : "";
          Object.keys(element) == "pdf_contrato_social"
            ? (documentos.pdf_contrato_social = element.pdf_contrato_social)
            : "";
          Object.keys(element) == "pdf_procuracao"
            ? (documentos.pdf_procuracao = element.pdf_procuracao)
            : "";
        }

        dados.dados_cadastrais = {
          tipo_pessoa: this.cadastro.dados_cadastrais.pessoa,
          razao_social: this.cadastro.dados_cadastrais.razao_social,
          cnpj: this.cadastro.dados_cadastrais.cnpj,

          representante_nome: this.cadastro.dados_cadastrais.nome_representante,
          representante_cpf: this.cadastro.dados_cadastrais.cpf,
          representante_rg: this.cadastro.dados_cadastrais.rg,
          representante_rg_orgao: this.cadastro.dados_cadastrais.rg_orgao,
          representante_email: this.cadastro.dados_cadastrais.email,
          celular: this.cadastro.dados_cadastrais.celular,

          nidregional: this.cadastro.dados_cadastrais.regional,
          status: this.cadastro.dados_cadastrais.status,
          idagente: "",
          idtipo_pdv: this.cadastro.dados_cadastrais.tipo_ponto_venda,

          end_cep: this.cadastro.dados_cadastrais.cep,
          end_estado: this.cadastro.dados_cadastrais.estado,
          end_cidade: this.cadastro.dados_cadastrais.cidade,
          end_bairro: this.cadastro.dados_cadastrais.bairro,
          end_logradouro: this.cadastro.dados_cadastrais.logradouro,
          end_complemento: this.cadastro.dados_cadastrais.complemento,
        };
      } else {
        for (
          let index = 0;
          index < this.cadastro.documentos.documento_array_pf.length;
          index++
        ) {
          const element = this.cadastro.documentos.documento_array_pf[index];

          Object.keys(element) == "pdf_comprovante_endereco"
            ? (documentos.pdf_comprovante_endereco =
                element.pdf_comprovante_endereco)
            : "";
          Object.keys(element) == "pdf_documento"
            ? (documentos.pdf_documento = element.pdf_documento)
            : "";
        }
        dados.dados_cadastrais = {
          tipo_pessoa: this.cadastro.dados_cadastrais.pessoa,
          representante_nome: this.cadastro.dados_cadastrais.nome_representante,
          representante_cpf: this.cadastro.dados_cadastrais.cpf,
          representante_rg: this.cadastro.dados_cadastrais.rg,
          representante_rg_orgao: this.cadastro.dados_cadastrais.rg_orgao,
          representante_email: this.cadastro.dados_cadastrais.email,
          representante_celular: this.cadastro.dados_cadastrais.celular,

          nidregional: this.cadastro.dados_cadastrais.regional,
          status: this.cadastro.dados_cadastrais.status,
          idagente: "",
          idtipo_pdv: this.cadastro.dados_cadastrais.tipo_ponto_venda,

          end_cep: this.cadastro.dados_cadastrais.cep,
          end_estado: this.cadastro.dados_cadastrais.estado,
          end_cidade: this.cadastro.dados_cadastrais.cidade,
          end_bairro: this.cadastro.dados_cadastrais.bairro,
          end_logradouro: this.cadastro.dados_cadastrais.logradouro,
          end_complemento: this.cadastro.dados_cadastrais.complemento,
        };
      }

      (dados.comissao_antecipacao = {
        comissao: this.cadastro.comissao_antecipacao.comissao,
        comissao_porcentagem_custom:
          this.cadastro.comissao_antecipacao.porcentagem_customizada,
        observacoes: this.cadastro.comissao_antecipacao.observacoes,
      }),
        (dados.dados_bancarios = {
          nome_titular: this.cadastro.dados_bancarios.nome_titular,
          banco: this.cadastro.dados_bancarios.banco,
          agencia: this.cadastro.dados_bancarios.agencia,
          tipo_conta: this.cadastro.dados_bancarios.tipo_de_conta,
          numero_conta: this.cadastro.dados_bancarios.numero_conta,
          digito_conta: this.cadastro.dados_bancarios.digito,
        }),
        (dados.documentos = documentos),
        (dados.equipamentos = {
          link_vendas: this.cadastro.equipamentos.link_venda,
          rede_vendas: this.cadastro.equipamentos.rede_vendas,
          loja: this.cadastro.equipamentos.selectedStore,
          equipamentos: equipamentos.join(";") || "",
        });

      const { idpdv } = this.cadastro;

      const { newPassword, confirmPassword, oldPassword } =
        this.cadastro.equipamentos;

      if (newPassword && oldPassword) {
        if (newPassword !== confirmPassword) {
          this.$config.alert(
            "As senhas não conferem",
            this.$config.dados.errorColor
          );
          return;
        }
        await put(CHANGE_SUPERVISOR_PASSWORD + idpdv, {
          senha_antiga: oldPassword,
          senha_nova: newPassword,
        });
      }

      put(UPDATE_POINTS_OF_SALE + this.cadastro.idpdv, dados)
        .then(response => {
          if (response) {
            this.$axios.setLocal("confirmEditPDV", true);
            this.clearPointOfSaleForm();
            router.push({
              name: "salePoint",
            });
          }
          this.cadastro.loading = false;
        })
        .catch(() => {
          this.cadastro.loading = false;
        });
    },

    /**
     * @description - Método para filtrar PDV's
     */
    pointOfSaleFilter() {
      const { post } = this.$axios;
      this.loading = true;
      this.filterLoading = true;
      this.filtros = [];
      function formatDate(date) {
        const dateParts = date.split("/");
        const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
        return formattedDate;
      }

      if (this.filter.nome != "") {
        this.filtros.push({
          campo: "representante_nome",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.nome,
        });
      }

      if (this.filter.cpf != "") {
        this.filtros.push({
          campo: "representante_cpf",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.cpf,
        });
      }

      if (this.filter.email != "") {
        this.filtros.push({
          campo: "representante_email",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.email,
        });
      }

      if (this.filter.cnpj != "") {
        this.filtros.push({
          campo: "cnpj",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.cnpj,
        });
      }

      if (this.filter.status != "" && this.filter.status != null) {
        this.filtros.push({
          campo: "status",
          tipo: "string",
          valor: this.filter.status,
        });
      }

      if (this.filter.tipoPessoa != "" && this.filter.tipoPessoa != null) {
        this.filtros.push({
          campo: "tipo_pessoa",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.tipoPessoa,
        });
      }

      if (this.filter.dataInicio != "") {
        this.filtros.push({
          campo: "ins_dthr",
          tipo: "date",
          orientacao: "maior",
          valor: formatDate(this.filter.dataInicio) + " 00:00",
        });
      }

      if (this.filter.dataFim != "") {
        this.filtros.push({
          campo: "ins_dthr",
          tipo: "date",
          orientacao: "menor",
          valor: formatDate(this.filter.dataFim) + " 23:59",
        });
      }

      let filtered = this.filtros;
      post(GET_POINTS_OF_SALE, JSON.stringify({ filtros: filtered })).then(
        response => {
          this.loading = false;
          this.filterLoading = false;
          this.pontos_de_venda = response;
        }
      );
    },

    /**
     * @description - Método para validar cadastro/alteração de PDV's
     */
    async registerValidate() {
      if (this.cadastro.dados_cadastrais.cnpj != "") {
        if (!this.$config.validarCNPJ(this.cadastro.dados_cadastrais.cnpj)) {
          this.$config.alert(
            "CNPJ inválido! (Dados Cadastrais)",
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.cnpj = "CNPJ inválido!";
          return;
        }
      }
      if (this.cadastro.dados_cadastrais.cpf != "") {
        if (!this.$config.validarCPF(this.cadastro.dados_cadastrais.cpf)) {
          this.$config.alert(
            "CPF inválido! (Dados Cadastrais)",
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.cpf = "CPF inválido!";
          return;
        }
      }
      if (this.cadastro.dados_cadastrais.pessoa === "JURIDICA") {
        if (
          this.cadastro.dados_cadastrais.nome_representante == null ||
          this.cadastro.dados_cadastrais.nome_representante.length < 5 ||
          this.cadastro.dados_cadastrais.nome_representante == ""
        ) {
          this.$config.alert(
            "Preencha o nome do representante corretamente! (Dados Cadastrais)",
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.nome_representante =
            "Preencha o nome do representante corretamente!";
          return;
        }
      } else {
        if (
          this.cadastro.dados_cadastrais.nome_representante == null ||
          this.cadastro.dados_cadastrais.nome_representante.length < 5 ||
          this.cadastro.dados_cadastrais.nome_representante == ""
        ) {
          this.$config.alert(
            "Preencha o nome do responsável corretamente! (Dados Cadastrais)",
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.nome_representante =
            "Preencha o nome do responsável corretamente!";
          return;
        }
      }
      if (
        this.cadastro.dados_cadastrais.email == "" ||
        this.cadastro.dados_cadastrais.email == null
      ) {
        this.$config.alert(
          "Preencha o e-mail corretamente! (Dados Cadastrais)",
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.email =
          "Preencha o e-mail corretamente!";
        return;
      }
      if (this.cadastro.dados_cadastrais.email != "") {
        if (!this.$config.validarEmail(this.cadastro.dados_cadastrais.email)) {
          this.$config.alert(
            "E-mail inválido! (Dados Cadastrais)",
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.email = "E-mail inválido!";
          return;
        }
      }
      if (
        this.cadastro.dados_cadastrais.regional == null ||
        this.cadastro.dados_cadastrais.regional == ""
      ) {
        this.$config.alert(
          "Selecione uma regional!  (Dados Cadastrais)",
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.regional =
          "Selecione uma regional!";
        return;
      }
      if (
        this.cadastro.dados_cadastrais.tipo_ponto_venda == "" ||
        this.cadastro.dados_cadastrais.tipo_ponto_venda == null
      ) {
        this.$config.alert(
          "Selecione o tipo de ponto de venda! (Dados Cadastrais)",
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.tipo_ponto_venda =
          "Selecione o tipo de ponto de venda!";
        return;
      }
      if (this.cadastro.comissao_antecipacao.comissao == "1") {
        if (
          this.cadastro.comissao_antecipacao.porcentagem_customizada == "" ||
          this.cadastro.comissao_antecipacao.porcentagem_customizada == null
        ) {
          this.$config.alert(
            "Preencha a porcentagem personalizada corretamente! (Dados Cadastrais)",
            this.$config.dados.errorColor
          );
          this.cadastro.comissao_antecipacao.error.porcentagem_customizada =
            "Preencha a porcentagem personalizada corretamente!";
          return;
        }
      }
      if (this.actionType == "editar") {
        this.changePointOfSale();
        return;
      }
      this.registerPointOfSale();
    },

    /**
     * @description Função que abre modal para confirmar remoção das configs adicionais
     */
    documentRemove(index, name, msg) {
      this.text = msg;
      this.funcao = "document";
      this.indexValue = index;
      this.indexImageOrDoc = index;
      this.valueImageOrDoc = name;
      this.$config.modalConfirm = true;
    },

    /**
     * @description Método para abrir o modal de confirmação de remoção de equipamento
     * @param {String} id - Id do equipamento a ser removido
     * @param {String} msg  - Mensagem de confirmação
     */
    removePointOfSale(id, msg) {
      document.getElementsByClassName(
        "modal-body-confirmacao"
      )[0].style.display = "flex";
      this.text = msg;
      this.cadastro.idpdv = id;
      this.funcao = "pdv";
    },

    /**
     * @description Função que confirma a remoção das configs adicionais
     */
    removeTrigger() {
      switch (this.funcao) {
        case "document":
          this.removeDOC(this.indexImageOrDoc, this.valueImageOrDoc);
          break;
        case "pdv":
          this.desabilitarPDV(this.cadastro.idpdv);
          break;
        default:
          // this.$loja_gerenciar.cadastro.configuracoes_adicionais.perguntas_frequentes.splice(this.indexValue, 1)
          break;
      }
    },

    /**
     * @description Função que remove a documento da loja
     */
    removeDOC(index, i) {
      if (this.cadastro.dados_cadastrais.pessoa == "FISICA") {
        this.cadastro.documentos.documento_array_pf.splice(index, 1);
        let tipo = this.tipo_docs_pf.find(item => item.value === i);
        if (tipo) {
          tipo.show = true;
        }
      } else {
        this.cadastro.documentos.documento_array_pj.splice(index, 1);
        let tipo = this.tipo_docs_pj.find(item => item.value === i);
        if (tipo) {
          tipo.show = true;
        }
      }
    },

    /**
     * @description Método para buscar status do ponto de venda
     */
    getPointOfSaleStatus() {
      const { get } = this.$axios;
      this.loading_status_pdv = true;
      get(`${GET_POINT_OF_SALE_STATUS}array`).then(response => {
        this.$axios.setLocal("status-pdv", response);
        this.status_pdv = response;
        this.loading_status_pdv = false;
      });
    },

    clearPointOfSaleForm() {
      /**
       * Limpa os campos de dados cadastrais
       */
      this.cadastro.dados_cadastrais.pessoa = "JURIDICA";
      this.cadastro.dados_cadastrais.razao_social = "";
      this.cadastro.dados_cadastrais.cnpj = "";
      this.cadastro.dados_cadastrais.nome_representante = "";
      this.cadastro.dados_cadastrais.cpf = "";
      this.cadastro.dados_cadastrais.rg = "";
      this.cadastro.dados_cadastrais.rg_orgao = "";
      this.cadastro.dados_cadastrais.email = "";
      this.cadastro.dados_cadastrais.celular = "";
      this.cadastro.dados_cadastrais.regional = "";
      this.cadastro.dados_cadastrais.status = "";
      this.cadastro.dados_cadastrais.agente_vinculado = "";
      this.cadastro.dados_cadastrais.tipo_ponto_venda = "";
      this.cadastro.dados_cadastrais.cep = "";
      this.cadastro.dados_cadastrais.estado = "";
      this.cadastro.dados_cadastrais.cidade = "";
      this.cadastro.dados_cadastrais.bairro = "";
      this.cadastro.dados_cadastrais.logradouro = "";
      this.cadastro.dados_cadastrais.complemento = "";

      /**
       * Limpa os campos de erro de dados cadastrais
       */
      this.cadastro.dados_cadastrais.error.razao_social = [];
      this.cadastro.dados_cadastrais.error.cnpj = [];
      this.cadastro.dados_cadastrais.error.nome_representante = [];
      this.cadastro.dados_cadastrais.error.cpf = [];
      this.cadastro.dados_cadastrais.error.rg = [];
      this.cadastro.dados_cadastrais.error.rg_orgao = [];
      this.cadastro.dados_cadastrais.error.email = [];
      this.cadastro.dados_cadastrais.error.celular = [];
      this.cadastro.dados_cadastrais.error.regional = [];
      this.cadastro.dados_cadastrais.error.status = [];
      this.cadastro.dados_cadastrais.error.agente_vinculado = [];
      this.cadastro.dados_cadastrais.error.tipo_ponto_venda = [];
      this.cadastro.dados_cadastrais.error.cep = [];
      this.cadastro.dados_cadastrais.error.estado = [];
      this.cadastro.dados_cadastrais.error.cidade = [];
      this.cadastro.dados_cadastrais.error.bairro = [];
      this.cadastro.dados_cadastrais.error.logradouro = [];

      /**
       * Limpa os campos de dados de comissão
       */
      this.cadastro.comissao_antecipacao.comissao = "3";
      this.cadastro.comissao_antecipacao.porcentagem_customizada = "";
      this.cadastro.comissao_antecipacao.observacoes = "";

      /**
       * Limpa os campos de erro de dados de comissão
       */
      this.cadastro.comissao_antecipacao.error.comissao = [];
      this.cadastro.comissao_antecipacao.error.porcentagem_customizada = [];

      /**
       * Limpa os campos de dados bancarios
       */
      this.cadastro.dados_bancarios.nome_titular = "";
      this.cadastro.dados_bancarios.banco = "";
      this.cadastro.dados_bancarios.agencia = "";
      this.cadastro.dados_bancarios.tipo_de_conta = "CORRENTE";
      this.cadastro.dados_bancarios.numero_conta = "";
      this.cadastro.dados_bancarios.digito = "";

      /**
       * Limpa os campos de erro de dados bancarios
       */
      this.cadastro.dados_bancarios.error.nome_titular = [];
      this.cadastro.dados_bancarios.error.banco = [];
      this.cadastro.dados_bancarios.error.agencia = [];
      this.cadastro.dados_bancarios.error.tipo_de_conta = [];
      this.cadastro.dados_bancarios.error.numero_conta = [];
      this.cadastro.dados_bancarios.error.digito = [];

      /**
       * Limpa os campos de cadastro dos documentos
       */
      this.cadastro.documentos.documento = "";
      this.cadastro.documentos.documento_upload.doc = null;
      delete this.cadastro.documentos.documento_upload.object;
      this.cadastro.documentos.loading_documento = false;
      this.cadastro.documentos.documento_array_pj = [];
      this.cadastro.documentos.documento_array_pf = [];

      /**
       * Limpa os campos de erro de cadastro dos documentos
       */
      this.cadastro.documentos.error.documento = [];

      /**
       * Limpa os campos do cadastro de contrato
       */
      this.cadastro.contratos.template = "";

      /**
       * Limpa os campos de erro do cadastro de contrato
       */
      this.cadastro.contratos.error.template = [];

      /**
       * Limpa os campos do cadastro de equipamentos
       */
      this.cadastro.equipamentos.link_venda = "";
      this.cadastro.equipamentos.rede_vendas = "PRIVADA";
      this.cadastro.equipamentos.selectedStore = null;
      this.cadastro.equipamentos.hasSupervisorPass = false;
      this.cadastro.equipamentos.supervisorPassword = "";
      this.cadastro.equipamentos.oldPassword = "";
      this.cadastro.equipamentos.newPassword = "";
      this.cadastro.equipamentos.confirmPassword = "";
      this.cadastro.equipamentos.equipamentos_array = [];
    },
  },
});
